import { getFontStyle } from '@medly-components/utils';
import styled from 'styled-components';

const MenuStyled = styled('div')`
    display: flex;
    flex-direction: column;
    padding: 0;
    width: 20rem;
    align-items: left;
    border-radius: 0.4rem;
    box-shadow: 0 0.2rem 0.8rem ${({ theme }) => theme.colors.grey[400]};
`;

const MenuItem = styled('button')`
    outline: none;
    border: none;
    text-decoration: none;
    padding: 0.8rem 2rem;
    cursor: pointer;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    background-color: ${({ theme }) => theme.colors.white};
    color: ${({ theme }) => theme.colors.darkBlue};
    ${({ theme }) => getFontStyle({ theme, fontVariant: 'body1', fontWeight: 'Regular' })}

    &:hover {
        background-color: ${({ theme }) => theme.colors.grey[100]};
    }
    &:active {
        background-color: ${({ theme }) => theme.colors.grey[200]};
    }
    &:first-child {
        border-radius: 0.4rem 0.4rem 0 0;
    }
    &:last-child {
        border-radius: 0 0 0.4rem 0.4rem;
    }

    svg {
        margin-right: 0.8rem;
    }
`;

export const Menu = Object.assign(MenuStyled, {
    Item: MenuItem
});
